import { useFragment } from 'react-relay';
import { fundsSelectionFragment } from './FundsSelection.relay';
import { FundsTable } from './lib/fundsTable';
import type { FundsSelectionPropsType } from './types';

const FundsSelection: React.FC<FundsSelectionPropsType> = (props) => {
  const component = useFragment(fundsSelectionFragment, props.component);

  return (
    <div className="Widget-container relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:mx-auto max-[1100px]:max-w-[565px] max-[1100px]:w-[calc(100vw-80px)] max-[600px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
      <div className="w-full">
        <h2 className="Base-title">{component.title}</h2>

        <FundsTable
          table={component.fundstable}
          salesAdmission={props.salesAdmission}
          currentLanguage={props.currentLanguage}
          locationState={props.location.state}
          location={props.location}
          downloadOverview={component.downloadOverview}
        />
      </div>
    </div>
  );
};

export { FundsSelection };
